import { gql } from '@apollo/client';

export const GET_NOTE_CONTENT = gql`
  query getNoteContent($noteId: ID!, $contentOptions: GetNoteContentOptions!) {
    getNote(noteId: $noteId) {
      noteId
      templateIdSelected
      organizeSelections {
        items {
          noteId
          selection
          Section
          EntityType
          IdentityLabel
          SharedId
          ActionSource
          SourceEventName
          UpdatedAt
          Unit
          Data
          DataType
        }
      }
    }
    getNoteContent(options: $contentOptions) {
      __typename
      ... on FreeText {
        Section
        selection
        Content
        Order
        CreatedAt
        ActionSource
        UpdatedAt
        UpdatedBy
        templateSelection {
          ComplaintId
          ComplaintName
          codes {
            id
            noteId
            code
            codeSystem
            display
            rank
            status
            createdAt
            updatedAt
            createdBy
            updatedBy
            actionSource
            referenceSelection
            referenceType
          }
        }
      }
      ... on Sentence {
        Section
        selection
        Content
        Order
        CreatedAt
        ActionSource
        UpdatedAt
        UpdatedBy
        templateSelection {
          ComplaintId
          ComplaintName
          codes {
            id
            noteId
            code
            codeSystem
            display
            rank
            status
            createdAt
            updatedAt
            createdBy
            updatedBy
            actionSource
            referenceSelection
            referenceType
          }
        }
      }
    }
  }
`;

export const REMINDER_GROUPS = gql`
  query ReminderGroups($noteId: ID!, $options: ReminderFilterInput) {
    getNote(noteId: $noteId) {
      noteId
      reminderGroups {
        id
        noteId
        groupType
        name
        encounterReminders(options: $options) {
          id
          status
          displayText
          reminder {
            alert
            name
          }
        }
      }
      reminderResponses {
        noteId
        dictation
        createdAt
      }
    }
  }
`;

export const NOTE_REVIEW = gql`
  query NoteReview($noteId: ID!) {
    getNote(noteId: $noteId) {
      noteId
      review {
        noteId
        CreatedAt
        UpdatedAt
        overallReview
        specificPoorReviews
        textResponse
      }
    }
  }
`;
